import { render, staticRenderFns } from "./yuzhi.vue?vue&type=template&id=30fd119a&scoped=true"
import script from "./yuzhi.vue?vue&type=script&lang=js"
export * from "./yuzhi.vue?vue&type=script&lang=js"
import style0 from "./yuzhi.vue?vue&type=style&index=0&id=30fd119a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fd119a",
  null
  
)

export default component.exports